import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CategoryServices from '../services/CategoryServices';
import useAsync from '../hooks/useAsync';
import HelpTogal from './TogelButton/HelpTogal';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import CategoryUpdate from './Update Model/UpdateCategory';
import SelectCategourySequence from './TogelButton/SelectCategorySequence';
import * as XLSX from 'xlsx';
Modal.setAppElement('#root');

function CategoryList() {
  const { data, error, isLoading, run } = useAsync(CategoryServices.getCategory);

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleEditDetails = (category) => {
    setSelectedEdit(category);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (category) => {
    setSelectedEdit(category);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11) and pad with leading zero
    const year = date.getFullYear(); // Get full year
    return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
  };


  // Filtered data based on search query
  const filteredData = data?.data?.filter(category =>
    category.title.toLowerCase().includes(searchQuery.toLowerCase().trim())
  );


  const generateExcel = () => {
    const filteredData = data?.data?.map(category => ({
      title: category?.title,
      image: process.env.REACT_APP_URL + category?.image,
      date: formatDateTime(category?.createdAt),
      status: category?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'CategoryData');
    XLSX.writeFile(wb, 'category_data.xlsx');
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Category List <span className="badge bg-orange">{filteredData?.length || 0}</span>
            </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Order
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="round-add-btn" to="/add-category">
              <img src="img/plus.svg" alt="Add Category" />
            </Link>
            <div className="pe-1 mb-xl-0">
              <button className="excel-btn" onClick={generateExcel}><img src="img/excel.svg" alt="Download" />Download</button>
            </div>
          </div>
        </div>


        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    value={searchQuery}
                    className='form-control'
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>

          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>IMAGE</th>
                  <th>CATEGORY NAME</th>
                  <th>SEQUENCE</th>
                  <th>DATE</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.map((category, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>

                    <td>
                      <div className="product-img">
                        <img
                          src={process.env.REACT_APP_URL + category?.image}
                          alt=""
                          style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                        />
                      </div>
                    </td>
                    <td>{category?.title}</td>
                    <td>
                      <SelectCategourySequence data={category} onSuccess={() => run()} />
                    </td>
                    <td>{formatDateTime(category?.createdAt)}</td>
                    <td className="status-toggle">
                      <HelpTogal help={category} page="Category" onSuccess={() => run()} />
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(category)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(category)}>Delete</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <CategoryUpdate category={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Category" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
      </div>
    </>
  );
}

export default CategoryList;
